const Configuration = require("../configuration.js");

window.CONFIGURATION = Configuration;
